export const environment = {
  production: false,
  apiUrl: 'https://devesignapi.ihostmyform.com/api',
  // apiUrl: 'https://api-saas-esign.avsstech.in/api',
  // apiUrl: 'http://192.168.1.125:3000/api',

  esignApiKey: 'sk_1788511276726_2P3YA90NP',
  estampApiKey: 'besk_1788511287698_LHV9QM6CT'
};

